import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MaterialModule } from '@core/material/material.module'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { AppSnackbarComponent } from './app-snackbar/app-snackbar.component'
import { InfoLabelDescriptionComponent } from './info-label-description/info-label-description.component'
import { PageTitleWithBackButtonComponent } from './page-title-with-back-button/page-title-with-back-button.component'
import { PageTitleComponent } from './page-title/page-title.component'
import { SearchFilterChipMultipleComponent } from './search-filter-chip-multiple/search-filter-chip-multiple.component'
import { SearchFilterChipRangeDateComponent } from './search-filter-chip-range-date/search-filter-chip-range-date.component'
import { SearchFilterChipComponent } from './search-filter-chip/search-filter-chip.component'
import { PipesModule } from '@core/pipes/pipes.module'
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component'
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component'
import { FormsModule } from '@angular/forms'
import { MatDialogModule } from '@angular/material/dialog'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatButtonModule } from '@angular/material/button'
import { DateRangeDialogComponent } from './date-range-dialog.component/date-range-dialog.component'
import { OverlayModule } from '@angular/cdk/overlay'
import { CustomTooltipComponent } from './custom-tooltip/custom.tooltip.component'

@NgModule({
  declarations: [
    AppSnackbarComponent,
    PageTitleComponent,
    PageTitleWithBackButtonComponent,
    SearchFilterChipComponent,
    SearchFilterChipMultipleComponent,
    SearchFilterChipRangeDateComponent,
    InfoLabelDescriptionComponent,
    ConfirmationDialogComponent,
    ConfirmDialogComponent,
    DateRangeDialogComponent,
    CustomTooltipComponent
  ],

  imports: [CommonModule, MaterialModule, NgxMaskDirective, PipesModule,
    FormsModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatButtonModule,
    OverlayModule
  ],
  exports: [
    AppSnackbarComponent,
    PageTitleComponent,
    PageTitleWithBackButtonComponent,
    SearchFilterChipComponent,
    SearchFilterChipMultipleComponent,
    SearchFilterChipRangeDateComponent,
    InfoLabelDescriptionComponent,
    ConfirmationDialogComponent,
    DateRangeDialogComponent,
    CustomTooltipComponent
  ],
  providers: [provideNgxMask()],
})
export class ComponentsModule { }
